import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userContextActions } from '../../store/userContextStore';
import { withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from "../../store/storeFunctions";
import { apiGet, getHostApi, hasPermission } from '../../store/apiWrapper';
import { writeErr } from '../common/logger';
import Message from "../common/message";
import Logo from '../../img/iRating';

import "./iratingComponent.scss"

const loginStatus = {
    new: 1,
    finished: 2,
    failed: 3
}

class IratingComponent extends React.Component {
    state = {
        loginStatus: loginStatus.new,
        token: null,
        url: null
    }

    render() {
        if (this.state.loginStatus === loginStatus.failed) {
            return (
                <div className="error-container error-container-wide">
                    <Message type="error" message={this.props.translate("Sso.Error")} />
                </div>
            )
        }
        if (!this.props.authentication.irating)
            return (
                <div className="sso-logo">
                    <div className="has-text-centered">
                        <Message type="warning" message={this.props.translate("IRating.NoRole").replace("{0}", "email")} options={{ renderInnerHtml: true }} />
                        <br />
                        <Logo />
                    </div>
                </div>
            );

        return (<>
            <div className="sso-logo">
                <div className="has-text-centered">
                    <h4 className="title is-3">{this.props.translate('Login.Redirecting')}</h4>
                    <h1 className="title is-1">{`${this.props.translate('Login.ToApp')} ${this.props.translate('NavBar.Irating')}`}</h1>
                    <br />
                    <Logo />
                </div>
            </div>
        </>);
    }

    componentDidMount() {
        if (this.props.authentication.irating)
            apiGet(
                `${getHostApi()}/api/sso/login-sso`,
                { application: "irating" },
                (success) => {
                    if (!isNullOrUndefined(success.data)) {
                        this.setState({ token: success.data.token, url: success.data.url, loginStatus: loginStatus.finished });
                        window.location = `${success.data.url}/login-sso?token=${success.data.token}`;
                    } else
                        this.setState({ loginStatus: loginStatus.failed });
                },
                (error) => {
                    writeErr(error);
                    this.setState({ loginStatus: loginStatus.failed });
                }
            );
    }
}

export default withLocalize(connect(
    state => ({ ...state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, userContextActions), dispatch)
)(IratingComponent));